export const ROOT_ZONE = 'ROOT'
export const CLIMATE_ZONE = 'CLIMATE'
